import { twMerge } from 'tailwind-merge';

export const Placeholder = ({ className, children }: { className?: string; children: React.ReactNode }) => (
    <div className={twMerge('rounded border border-gray-300 bg-white p-2', className)}>{children}</div>
);
